module.exports = __webpack_public_path__ + "static/knight-king-9a0e45074791f17fd24baed017d7ef3b.jpg";